import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import 'react-table/react-table.css';
import {
    getFormModules, getFormType, getModuleType,
    setInitialState, setRowInReducer, deleteFormModule
} from '../../../actions/control_panel/FormModuleActions';
import i18n from '../../../i18n/i18n';
import Select from 'react-select';
import immutable from 'seamless-immutable';
import { Fab } from '@material-ui/core';
import AddFormModules from './AddFormModules';
import { Delete } from '../../../utils/Delete';
const CheckboxTable = checkboxHOC(ReactTable);;

export class ViewFormModules extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showFilters: false,
            add: false,
            selection: [],
            selectAll: false,
            edit: false,
            delete: false,
        };
        this.tableScrollTop = 0;
    }

    componentDidMount() {
        if (this.props.formType.length == 0) {
            this.props.getFormType();
        }
        if (this.props.moduleType.length == 0) {
            this.props.getModuleType();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.deleted === true) {
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getFormModules(wrapped.state);
            this.setState({
                selection: [],
                selectAll: false,
            })
            this.props.setInitialState('formModuleObj');
            this.props.setInitialState('deleted');
        }
        if (nextProps.formModulePostingSuccess === true) {
            this.setState({
                selection: [],
                name: '',
                selectAll: false
            })
            this.handleClick();
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getFormModules(wrapped.state);
            this.props.setInitialState('formModulePostingSuccess');
        }

        this.setState({
            formModule: nextProps.formModule,
            formModuleFetching: nextProps.formModuleFetching,

            formType: immutable.asMutable(nextProps.formType.map((item) => { return { label: item.naziv_prozora, value: item.id } }), { deep: true }),
            formTypeFetching: nextProps.formTypeFetching,
            formTypeFetchingFailed: nextProps.formTypeFetchingFailed,

            moduleType: immutable.asMutable(nextProps.moduleType.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            moduleTypeFetching: nextProps.moduleTypeFetching,
            moduleTypeFetchingFailed: nextProps.moduleTypeFetchingFailed,
        })
    }

    onSearchClick() {
        this.setState({ showFilters: !this.state.showFilters });
    }

    onExportClick = () => {
        this.setState({ export: !this.state.export });
    }

    handleClick = () => {
        if (this.state.edit == true && this.state.add == false) {
            this.setState({ edit: false })
            this.props.setInitialState('formModuleObj');
        } else if (this.state.selection.length > 0 && this.state.add == false && this.state.edit == false) {
            this.props.setInitialState('formModuleObj');
        }
        this.setState({ add: !this.state.add }, () => {
            if (this.state.add == true && this.state.edit == false) {
                this.setState({
                    selection: [],
                    name: '',
                    selectAll: false,
                })
            }
        });
    };

    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
            this.props.setInitialState('formModuleObj');
        } else {
            selection.push(key);
        }
        this.setState({ selection }, function () {
            if (selection.length == 1) {
                let row1 = this.props.formModule.filter((fm) => {
                    return fm.id == selection;
                })
                this.props.setRowInReducer(row1[0], 'formModuleObj');
            }
        });
    };

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                selection.push(item._original.id);
            });
        }
        this.setState({ selectAll, selection });
    };

    isSelected = key => {
        return this.state.selection.includes(key);
    };

    onDeleteClick = () => {
        this.setState({ delete: !this.state.delete });
    }

    deleteItem = () => {
        this.props.deleteFormModule(this.state.selection);
        this.setState({ delete: false })
    }

    onEditClick() {
        this.setState({ add: !this.state.add, edit: true });
    }

    onTableClick = () => {
        this.props.history.push('/form_module');
    }


    render() {
        const columns = [
            {
                Header: i18n.t('ID'),
                accessor: 'id'
            },
            {
                Header: i18n.t('Module'),
                accessor: 'naziv_modula',
                Filter: ({ filter, onChange }) =>
                    <Select
                        isMulti
                        name="naziv"
                        onChange={value => {
                            onChange(value)
                        }}
                        closeMenuOnSelect={false}
                        options={this.state.moduleType}
                        className="multi-select-in-filter"
                        classNamePrefix="select"
                        placeholder={i18n.t('Select')}
                    />
            },
            {
                Header: i18n.t('Form'),
                accessor: 'naziv_forme',
                Filter: ({ filter, onChange }) =>
                    <Select
                        isMulti
                        name="naziv"
                        onChange={value => {
                            onChange(value)
                        }}
                        closeMenuOnSelect={false}
                        options={this.state.formType}
                        className="multi-select-in-filter"
                        classNamePrefix="select"
                        placeholder={i18n.t('Select')}
                    />
            },
            {
                id: 'aktivan',
                Header: i18n.t('Active'),
                accessor: d => d.pravi, // Custom value accessors!
                Cell: ({ value }) => value != 0 ? i18n.t('Yes') : i18n.t('No')
            },
        ];

        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll } = this.state;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return {
                        style: {
                            backgroundColor: selected ? "lightgreen" : "inherit"
                        }
                    };
                }
                return {};
            }
        };
        return (
            <div className="page">
                <div className="table-header">
                    <Fab onClick={() => this.handleClick()}
                        color="primary"
                        aria-label="add"
                        className="action-button">
                        <span className="icon-Plus headerIcon" />
                    </Fab>
                    <Fab onClick={() => this.onSearchClick()}
                        color="primary"
                        aria-label="add"
                        className="action-button"    >
                        <span className="icon-search headerIcon" />
                    </Fab>

                    {this.state.selection.length > 0 ?
                        <Fab onClick={() => this.onDeleteClick()}
                            color="primary"
                            aria-label="add"
                            className="action-button">
                            <span className="icon-Kanta headerIcon" />
                        </Fab>
                        : null
                    }
                    {this.state.selection.length === 1 ?
                        <Fab onClick={() => this.onEditClick()}
                            color="primary"
                            aria-label="edit"
                            className="action-button">
                            <span className="icon-Izmeni1 headerIcon" />
                        </Fab>
                        : null
                    }
                </div>
                <CheckboxTable ref={r => (this.checkboxTable = r)}
                    data={this.props.formModule}
                    getTheadFilterThProps={() => { return { style: { position: "inherit", overflow: "inherit" } } }}
                    columns={columns}
                    keyField={'id'}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={this.state.showFilters}
                    pages={this.props.formModulePages}
                    loading={this.props.formModuleFetching}
                    manual
                    showPaginationTop
                    showPaginationBottom={false}
                    onFetchData={(state, instance) => this.props.getFormModules(state, instance)}
                    className="-striped -highlight"
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps} />

                {this.state.add && <AddFormModules add={this.state.add} edit={this.state.edit} handleClose={this.handleClick} />}
                {this.state.delete && <Delete delete={this.state.delete} handleClose={this.onDeleteClick} deleteItem={this.deleteItem} />}

            </div>
        )
    }
};

function mapStateToProps(state) {
    return {
        formModule: state.formModuleReducer.formModule,
        formModuleFetching: state.formModuleReducer.formModuleFetching,
        formModulePages: state.formModuleReducer.formModulePages,
        formModuleObj: state.formModuleReducer.formModuleObj,
        formModulePostingSuccess: state.formModuleReducer.formModulePostingSuccess,

        deleted: state.formModuleReducer.deleted,

        formType: state.formModuleReducer.formType,
        formTypeFetching: state.formModuleReducer.formTypeFetching,
        formTypeFetchingFailed: state.formModuleReducer.formTypeFetchingFailed,

        moduleType: state.formModuleReducer.moduleType,
        moduleTypeFetching: state.formModuleReducer.moduleTypeFetching,
        moduleTypeFetchingFailed: state.formModuleReducer.moduleTypeFetchingFailed,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getFormModules: (state, instance) => dispatch(getFormModules(state, instance)),

        setInitialState: (component) => dispatch(setInitialState(component)),
        setRowInReducer: (rowInfo) => dispatch(setRowInReducer(rowInfo)),

        deleteFormModule: (selection) => dispatch(deleteFormModule(selection)),

        getFormType: () => dispatch(getFormType()),
        getModuleType: () => dispatch(getModuleType()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewFormModules);